import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container d-flex align-items-center justify-content-center custom-background-height py-5" }
const _hoisted_2 = { class: "col-12 col-sm-10 col-md-7 col-lg-6 col-xl-4 shadow rounded-4 p-4 bg-pink" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-primary fw-normal mb-4" }, "Forgot Password?", -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "text-end mb-5" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "fa fa-spinner fa-spin",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "my-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-0 text-secondary text-center fw-lighter" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Sign Up if you don't have an account")
], -1)
const _hoisted_10 = { class: "my-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mb-0 text-secondary text-center fw-lighter" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Sign In if you have an account")
], -1)

import router from "@/router";
import { ref, reactive } from "vue";
import { toast } from "vue3-toastify";
import { impalaApi } from "@/main.ts";
import BaseInputPill from "@/components/base-components/BaseInputPill.vue";


const __default__ = {
  name: "ForgotPassword",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false);
const form = reactive({ email: "" });

const submit = async () => {
  try {
    loading.value = true;
    await impalaApi.post("/auth/forgot-password", form);
    toast.success("Mail sent successfully!");
    await router.push("/check-mail");
  } catch (error: never) {
    toast.error(error.response.data);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"]),
          role: "form",
          class: "ui form"
        }, [
          _createVNode(BaseInputPill, {
            value: form.email,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
            name: "username-email-sign-in",
            type: "text",
            id: "username-email-sign-in",
            "aria-placeholder": "Username or Email Address",
            placeholder: "Username or Email Address",
            required: ""
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              disabled: loading.value,
              type: "submit",
              class: "btn btn-info text-white rounded-pill"
            }, [
              _createTextVNode(" Get New Password! "),
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6)
          ])
        ], 40, _hoisted_4),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "btn bg-light shadow mb-2 rounded-pill w-100 text-decoration-none text-primary border border-1 border-primary border-opacity-50",
            to: { name: 'SignUp' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign Up! ")
            ]),
            _: 1
          }),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "btn bg-light shadow mb-2 rounded-pill w-100 text-decoration-none text-primary border border-1 border-primary border-opacity-50",
            to: { name: 'SignIn' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign In! ")
            ]),
            _: 1
          }),
          _hoisted_11
        ])
      ])
    ])
  ]))
}
}

})